import { render, staticRenderFns } from "./ManageProductPlus.vue?vue&type=template&id=415c8424"
import script from "./ManageProductPlus.vue?vue&type=script&lang=js"
export * from "./ManageProductPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports